// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fuel-banner {
  text-align: center;
}
.fuel-banner.fuel-banner-desktop {
  margin: var(--spacing-small) var(--spacing-extra-big);
}
.fuel-banner.fuel-banner-desktop img {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
}
.fuel-banner.fuel-banner-mobile {
  margin: var(--spacing-small);
}
.fuel-banner.fuel-banner-mobile img {
  border-radius: 16px;
  overflow: hidden;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/fuelCredit/FuelCreditBanner.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAAI;EACI,qDAAA;AAER;AAHI;EAII,WAAA;EACA,mBAAA;EACA,gBAAA;AAER;AACI;EACI,4BAAA;AACR;AAFI;EAGI,mBAAA;EACA,gBAAA;EACA,eAAA;AAER","sourcesContent":[".fuel-banner {\n    text-align: center;\n    &.fuel-banner-desktop {\n        margin: var(--spacing-small) var(--spacing-extra-big);\n\n      img {\n        width: 100%;\n        border-radius: 16px;\n        overflow: hidden;\n      }\n    } \n    &.fuel-banner-mobile {\n        margin: var(--spacing-small);\n      img {\n        border-radius: 16px;\n        overflow: hidden;\n        max-width: 100%;\n      }\n    } \n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
